<template>
  <div>
    {{locale.register.paymentRedirect}}
    <a :href="this.responseData.data.redirect">{{locale.register.paymentHere}}</a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'RegisterPayment',
  components: { errorMessages },
  computed: mapState([
    'locale'
  ]),
  props: [ 'responseData' ],
  created () {
    this.$emit('activeStep', 1)
    setTimeout(window.location.replace(this.responseData.data.redirect), 3000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterPayment.vue